import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import type {
  IServiceApi,
  TGetServiceByIdParams,
  TGetServicesParams,
  TUpdateServiceByIdRequestBody,
  TDeleteServicesParams,
  TUpdateServiceByIdParams
} from '@/types/api-types/services'
import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import ServiceApiUrl from './endpoints'
import BaseApiRequest from '../BaseApiRequest'

class ServiceApiRequest extends BaseApiRequest implements IServiceApi {
  async getService(params: TGetServiceByIdParams): TApiResponse {
    const { id, ...rest } = params
    const url = `${ServiceApiUrl.SERVICE_BY_ID(params.id)}`
    return this.get(url, rest)
  }

  async updateService(
    params: TUpdateServiceByIdParams,
    requestBody: TUpdateServiceByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${ServiceApiUrl.SERVICE_BY_ID(id)}`
    return this.put(url, requestBody, rest)
  }

  async getServices(params: TGetServicesParams): TApiResponse {
    return this.get(ServiceApiUrl.SERVICES(), params)
  }

  async getServicesTasks(params: TGetServicesParams): TApiResponse {
    return this.get(ServiceApiUrl.SERVICES_TASKS(), params)
  }

  async deleteServices(
    params?: TDeleteServicesParams
  ): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(ServiceApiUrl.SERVICES(), params)
  }

  async createService(requestBody: TUpdateServiceByIdRequestBody, params?: any): TApiResponse {
    return this.post(ServiceApiUrl.SERVICES(), requestBody, params)
  }
}

export default ServiceApiRequest
